function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { ShippingMethods, VINOMOFO_WAREHOUSE_ADDRESS } from "@utils/constants";
import { normalizePhoneNumber } from "@/src/components/form-fields/Masks";
import { phoneRegEx } from "@/src/types";
import { getLastGoodAddresses, hasPaypalResyncMarker, PAYPAL_RESYNC_MARKER } from "@components/payment/methods/lastGoodAddress";
var isSG = process.env.VM_MARKET === "SG";
export var getIsInstrumentFeatureAvailable = function getIsInstrumentFeatureAvailable(_ref) {
  var _paymentMethod$config;
  var customer = _ref.customer,
    paymentMethod = _ref.paymentMethod;
  if (
  // Disable this, for some reason this flag/field is now always returning null
  // and there is no way for us now to enable/disable this on BC dashboard.
  // Fortunately "isCardVaultingEnabled" on selected payment method is still available
  // !config?.checkoutSettings?.isCardVaultingEnabled ||
  // config?.checkoutSettings?.isCardVaultingEnabled === null ||

  !(paymentMethod !== null && paymentMethod !== void 0 && (_paymentMethod$config = paymentMethod.config) !== null && _paymentMethod$config !== void 0 && _paymentMethod$config.isVaultingEnabled) || customer !== null && customer !== void 0 && customer.isGuest) {
    return false;
  }
  return true;
};
export var isInstrumentCardCodeRequired = function isInstrumentCardCodeRequired(_ref2) {
  var instrument = _ref2.instrument,
    paymentMethod = _ref2.paymentMethod,
    lineItems = _ref2.lineItems;
  // If there's a digital item in the cart, always show CVV field
  if (lineItems.digitalItems.length > 0 || lineItems.giftCertificates.length > 0) {
    return true;
  }

  // If the shipping address is trusted, show CVV field based on the merchant's configuration
  if (instrument.trustedShippingAddress) {
    return !!paymentMethod.config.isVaultingCvvEnabled;
  }

  // Otherwise, if the shipping address is untrusted, show CVV field if the
  // merchant either requires it for regular card or stored card payments.
  return !!(paymentMethod.config.isVaultingCvvEnabled || paymentMethod.config.cardCode);
};
export var isInstrumentCardNumberRequired = function isInstrumentCardNumberRequired(_ref3) {
  var instrument = _ref3.instrument,
    lineItems = _ref3.lineItems;
  if (lineItems.physicalItems.length === 0) {
    return false;
  }
  return !instrument.trustedShippingAddress;
};
export var getDefaultInstrument = function getDefaultInstrument(instruments) {
  if (!instruments.length) {
    return;
  }
  return instruments.find(function (instrument) {
    return instrument.defaultInstrument;
  }) || instruments[0];
};
export var isCardInstrument = function isCardInstrument(instrument) {
  var _ref4 = instrument,
    type = _ref4.type,
    expiryMonth = _ref4.expiryMonth,
    expiryYear = _ref4.expiryYear;
  return type === "card" && !isExpired(Number(expiryMonth), Number(expiryYear));
};
export var isExpired = function isExpired(expiryMonth, expiryYear) {
  var currentYear = new Date().getFullYear();
  var currentMonth = new Date().getMonth() + 1;
  if (expiryYear < currentYear) {
    return true;
  } else if (expiryYear === currentYear && expiryMonth < currentMonth) {
    return true;
  }
  return false;
};

// Tiny timing helper shared by the wallet buttons.
export var wait = function wait(ms) {
  return new Promise(function (r) {
    return setTimeout(r, ms);
  });
};

/**
 * Ensures lastName is not empty - falls back to firstName if empty.
 * This prevents payment failures in Apple Pay, Google Pay, PayPal, and Afterpay
 * when the payment provider returns an empty lastName.
 */
export var ensureLastName = function ensureLastName(firstName, lastName) {
  var trimmedLastName = (lastName || "").trim();
  if (trimmedLastName) return trimmedLastName;
  return (firstName || "").trim() || "Customer";
};

// Phone validity check mirroring ShippingAddress: AU numbers are compared with
// spaces stripped (the canonical mask carries spaces), SG as-is.
var phonePassesRegEx = function phonePassesRegEx(phone) {
  return phoneRegEx.test(isSG ? phone : phone.replace(/ /g, ""));
};

// Canonicalise a stored phone: keep it when already valid, else FORMAT-repair a
// recoverable one (`+61` / `61…` prefix, missing leading 0) via
// normalizePhoneNumber. Returns "" when unrecoverable so callers can fall back
// to another source.
var alignPhone = function alignPhone(phone) {
  var trimmed = (phone || "").trim();
  if (!trimmed) return "";
  if (phonePassesRegEx(trimmed)) return trimmed;
  var repaired = normalizePhoneNumber(trimmed, {
    quiet: true
  });
  return repaired && phonePassesRegEx(repaired) ? repaired : "";
};

// Cap the (networked) previous-order lookup so a slow/hung request can't stall
// a submit; on timeout we fall through to the remaining phone sources.
var PREV_ORDER_PHONE_TIMEOUT_MS = 2500;
var withPhoneTimeout = function withPhoneTimeout(p) {
  return Promise.race([p, new Promise(function (resolve) {
    return setTimeout(function () {
      return resolve(undefined);
    }, PREV_ORDER_PHONE_TIMEOUT_MS);
  })]);
};

/**
 * Ensures the cart's shipping + billing address carries a VALID phone before an
 * order is submitted / authorised, and reports whether it succeeded.
 *
 * A returning shopper's restored last-used address can hold a phone in
 * international format (e.g. `61431826414`, a valid AU mobile), and PayPal may
 * return an address with no phone at all. BigCommerce's client validation gates
 * such an address, but the offsite wallet paths (PayPal especially) can still
 * authorise an order whose phone the downstream **capture** then rejects —
 * leaving the shopper with an authorised-but-uncaptured payment and no order.
 *
 * Heal sequence (mirrors how ShippingAddress heals the address), first usable
 * wins:
 *   1. the current shipping phone, format-repaired (`+61` / `61…` / missing 0)
 *   2. the billing phone
 *   3. the previous order's phone (via `getPreviousOrderPhone`, time-boxed)
 *   4. the most-recently-added saved address's phone
 *
 * Persists the healed value to shipping + billing. Returns `true` when the order
 * ends with a valid phone (already valid, or successfully healed) and `false`
 * when no usable phone exists anywhere — callers on offsite/PayPal paths use the
 * `false` result to abort *before* authorising, so the shopper isn't stranded
 * with an uncapturable payment. Swallows its own errors (returns `false`).
 */
export var healInvalidPhone = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(checkoutService, getPreviousOrderPhone) {
    var _state$data, _state$data2, _state$data$getCustom, _state$data3, _state$data4, state, shipping, current, candidates, saved, _iterator, _step, addr, fixed, _i, _candidates, candidate, aligned, billing, _t, _t2;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          state = checkoutService.getState();
          shipping = (_state$data = state.data) === null || _state$data === void 0 ? void 0 : _state$data.getShippingAddress();
          if (shipping) {
            _context.n = 1;
            break;
          }
          return _context.a(2, false);
        case 1:
          current = (shipping.phone || "").trim();
          if (!(current && phonePassesRegEx(current))) {
            _context.n = 2;
            break;
          }
          return _context.a(2, true);
        case 2:
          // already valid
          // Candidate sources, in priority order.
          candidates = [current, (_state$data2 = state.data) === null || _state$data2 === void 0 || (_state$data2 = _state$data2.getBillingAddress()) === null || _state$data2 === void 0 ? void 0 : _state$data2.phone];
          if (!getPreviousOrderPhone) {
            _context.n = 4;
            break;
          }
          _t = candidates;
          _context.n = 3;
          return withPhoneTimeout(getPreviousOrderPhone());
        case 3:
          _t.push.call(_t, _context.v);
        case 4:
          saved = (_state$data$getCustom = (_state$data3 = state.data) === null || _state$data3 === void 0 || (_state$data3 = _state$data3.getCustomer()) === null || _state$data3 === void 0 ? void 0 : _state$data3.addresses) !== null && _state$data$getCustom !== void 0 ? _state$data$getCustom : [];
          _iterator = _createForOfIteratorHelper(_toConsumableArray(saved).sort(function (a, b) {
            var _b$id, _a$id;
            return ((_b$id = b.id) !== null && _b$id !== void 0 ? _b$id : 0) - ((_a$id = a.id) !== null && _a$id !== void 0 ? _a$id : 0);
          }));
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              addr = _step.value;
              candidates.push(addr.phone);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          fixed = "";
          _i = 0, _candidates = candidates;
        case 5:
          if (!(_i < _candidates.length)) {
            _context.n = 7;
            break;
          }
          candidate = _candidates[_i];
          aligned = alignPhone(candidate);
          if (!aligned) {
            _context.n = 6;
            break;
          }
          fixed = aligned;
          return _context.a(3, 7);
        case 6:
          _i++;
          _context.n = 5;
          break;
        case 7:
          if (fixed) {
            _context.n = 8;
            break;
          }
          return _context.a(2, false);
        case 8:
          _context.n = 9;
          return checkoutService.updateShippingAddress(_objectSpread(_objectSpread({}, shipping), {}, {
            phone: fixed
          }));
        case 9:
          billing = (_state$data4 = state.data) === null || _state$data4 === void 0 ? void 0 : _state$data4.getBillingAddress();
          if (!billing) {
            _context.n = 10;
            break;
          }
          _context.n = 10;
          return checkoutService.updateBillingAddress(_objectSpread(_objectSpread({}, billing), {}, {
            phone: fixed
          }));
        case 10:
          return _context.a(2, true);
        case 11:
          _context.p = 11;
          _t2 = _context.v;
          return _context.a(2, false);
      }
    }, _callee, null, [[0, 11]]);
  }));
  return function healInvalidPhone(_x, _x2) {
    return _ref5.apply(this, arguments);
  };
}();

// The specific broken shipping address that keeps coming through (almost always
// via PayPal): a unit/street line with the rest of the address missing, while
// billing is correct. We ONLY overwrite shipping when it matches this exact
// value -- any other shipping address (including a legitimately different
// ship-to) is left untouched. Matched case-insensitively, whitespace-collapsed.
var KNOWN_BAD_SHIPPING_ADDRESS1 = "5a/339 bridge st";
var isKnownBadShippingAddress = function isKnownBadShippingAddress(shipping) {
  var addr1 = ((shipping === null || shipping === void 0 ? void 0 : shipping.address1) || "").trim().toLowerCase().replace(/\s+/g, " ");
  return addr1.includes(KNOWN_BAD_SHIPPING_ADDRESS1);
};

/**
 * PayPal-only heal for a single known-bad shipping address. When the cart's
 * shipping address is the corrupted `"5a/339 Bridge St"` value, overwrite it
 * with the (correct) billing address so the order is deliverable and captures.
 *
 * Deliberately narrow: it is a no-op for every other shipping address, so a
 * shopper who legitimately ships somewhere other than their billing address is
 * never affected. Re-selects a shipping option afterwards (BC drops it on a
 * zone change) and swallows its own errors so it can't block a submit.
 */
export var copyBillingToShippingIfKnownBad = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(checkoutService) {
    var _state$data5, _state$data6, _billing$address, state, shipping, billing, merged, result, refreshed, _refreshed$getShippin, _opts$find, _checkoutService$getS, opts, next, _t3;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          _context2.p = 0;
          state = checkoutService.getState();
          shipping = (_state$data5 = state.data) === null || _state$data5 === void 0 ? void 0 : _state$data5.getShippingAddress();
          if (isKnownBadShippingAddress(shipping)) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2);
        case 1:
          // only the known-bad address
          billing = (_state$data6 = state.data) === null || _state$data6 === void 0 ? void 0 : _state$data6.getBillingAddress();
          if (billing !== null && billing !== void 0 && (_billing$address = billing.address1) !== null && _billing$address !== void 0 && _billing$address.trim()) {
            _context2.n = 2;
            break;
          }
          return _context2.a(2);
        case 2:
          // need a real billing address to copy
          // Copy billing's address fields onto shipping; keep shipping-only fields
          // (notably `customFields`, e.g. delivery instructions) in place.
          merged = _objectSpread(_objectSpread({}, shipping), {}, {
            firstName: billing.firstName,
            lastName: billing.lastName,
            company: billing.company,
            address1: billing.address1,
            address2: billing.address2,
            city: billing.city,
            stateOrProvince: billing.stateOrProvince,
            stateOrProvinceCode: billing.stateOrProvinceCode,
            postalCode: billing.postalCode,
            countryCode: billing.countryCode,
            country: billing.country,
            phone: billing.phone
          });
          _context2.n = 3;
          return checkoutService.updateShippingAddress(merged);
        case 3:
          result = _context2.v;
          // BC drops the selected shipping option on a zone change; re-select a valid
          // one so the subsequent submitOrder isn't rejected for a missing option.
          refreshed = result === null || result === void 0 ? void 0 : result.data;
          if (!(refreshed && !refreshed.getSelectedShippingOption())) {
            _context2.n = 4;
            break;
          }
          opts = (_refreshed$getShippin = refreshed.getShippingOptions()) !== null && _refreshed$getShippin !== void 0 ? _refreshed$getShippin : [];
          next = (_opts$find = opts.find(function (o) {
            return o.type === ShippingMethods.SHIPPING_OPTION_FREE || o.type === ShippingMethods.SHIPPING_OPTION_STANDARD || o.type === ShippingMethods.SHIPPING_OPTION_PERITEM || o.type === ShippingMethods.SHIPPING_BYTOTAL;
          })) !== null && _opts$find !== void 0 ? _opts$find : opts[0];
          if (!(next && !((_checkoutService$getS = checkoutService.getState().statuses) !== null && _checkoutService$getS !== void 0 && _checkoutService$getS.isSelectingShippingOption()))) {
            _context2.n = 4;
            break;
          }
          _context2.n = 4;
          return checkoutService.selectShippingOption(next.id);
        case 4:
          _context2.n = 6;
          break;
        case 5:
          _context2.p = 5;
          _t3 = _context2.v;
        case 6:
          return _context2.a(2);
      }
    }, _callee2, null, [[0, 5]]);
  }));
  return function copyBillingToShippingIfKnownBad(_x3) {
    return _ref6.apply(this, arguments);
  };
}();

// PayPal's stub strips the street line AND the first/last name (keeping only
// city/state/postcode), so treat a missing name as "wiped" too — a billing
// address that kept address1 but lost its names still fails BC as
// `invalid_billing_address`.
export var isStubAddress = function isStubAddress(addr) {
  var _addr$address, _addr$firstName, _addr$lastName;
  return !(addr !== null && addr !== void 0 && (_addr$address = addr.address1) !== null && _addr$address !== void 0 && _addr$address.trim()) || !(addr !== null && addr !== void 0 && (_addr$firstName = addr.firstName) !== null && _addr$firstName !== void 0 && _addr$firstName.trim()) || !(addr !== null && addr !== void 0 && (_addr$lastName = addr.lastName) !== null && _addr$lastName !== void 0 && _addr$lastName.trim());
};

// A usable restore source must have the fields PayPal wipes (street + names),
// and must not be a previous heal's perturbing write (see PAYPAL_RESYNC_MARKER).
var isCompleteSource = function isCompleteSource(addr) {
  return !isStubAddress(addr) && !hasPaypalResyncMarker(addr);
};

// A PayPal locality-only stub keeps the postcode/state/city it copied off the
// cart but drops the street + names (and phone). We use this — not the broader
// `isStubAddress` — to trigger the load-time heal so it fires ONLY for the wipe
// signature (locality present, street/name gone) and never for a genuinely
// empty address on a fresh checkout (nothing to restore, and firing there would
// auto-write a saved address onto every load).
export var isPaypalWipedStub = function isPaypalWipedStub(addr) {
  var _addr$postalCode, _addr$city;
  return isStubAddress(addr) && !!(addr !== null && addr !== void 0 && (_addr$postalCode = addr.postalCode) !== null && _addr$postalCode !== void 0 && _addr$postalCode.trim() || addr !== null && addr !== void 0 && (_addr$city = addr.city) !== null && _addr$city !== void 0 && _addr$city.trim());
};

/** Maps a saved CustomerAddress onto the checkout Address shape (drops id/type). */
var customerAddressToAddress = function customerAddressToAddress(a) {
  var _a$customFields;
  return {
    firstName: a.firstName,
    lastName: a.lastName,
    company: a.company,
    address1: a.address1,
    address2: a.address2,
    city: a.city,
    stateOrProvince: a.stateOrProvince,
    stateOrProvinceCode: a.stateOrProvinceCode,
    country: a.country,
    countryCode: a.countryCode,
    postalCode: a.postalCode,
    phone: a.phone,
    customFields: (_a$customFields = a.customFields) !== null && _a$customFields !== void 0 ? _a$customFields : [],
    shouldSaveAddress: true
  };
};

/**
 * Picks the saved address that best matches a wiped stub. PayPal keeps the
 * stub's postcode/state, so we prefer the saved address with the same locality
 * (i.e. the one that was actually wiped), falling back to the first complete
 * saved address so a logged-in shopper isn't left at a 422.
 */
var pickSavedAddressForStub = function pickSavedAddressForStub(saved, stub) {
  var complete = saved.filter(function (a) {
    var _a$address, _a$firstName, _a$lastName, _a$address2;
    return !!((_a$address = a.address1) !== null && _a$address !== void 0 && _a$address.trim()) && !!((_a$firstName = a.firstName) !== null && _a$firstName !== void 0 && _a$firstName.trim()) && !!((_a$lastName = a.lastName) !== null && _a$lastName !== void 0 && _a$lastName.trim()) && !a.address1.includes(PAYPAL_RESYNC_MARKER) && !((_a$address2 = a.address2) !== null && _a$address2 !== void 0 && _a$address2.includes(PAYPAL_RESYNC_MARKER));
  });
  if (!complete.length) return undefined;
  var match = complete.find(function (a) {
    return a.postalCode === (stub === null || stub === void 0 ? void 0 : stub.postalCode) && (a.stateOrProvinceCode === (stub === null || stub === void 0 ? void 0 : stub.stateOrProvinceCode) || a.city === (stub === null || stub === void 0 ? void 0 : stub.city));
  });
  return customerAddressToAddress(match !== null && match !== void 0 ? match : complete[0]);
};

// True while `healPaypalWipedAddress` is mid-write. Its perturbing write makes
// the marker briefly visible in checkout state; the scrub must not race the
// heal's own clean write.
var healInFlight = false;
// Prevents the submit guard and the wallet effect scrubbing concurrently.
var scrubInFlight = false;

/**
 * Submit-time heal for PayPal's "locality-only" address wipe. When the PayPal
 * Smart Button's wallet opens it overwrites the cart's billing + shipping with
 * a stub that keeps only city/state/postcode (empty street, name and phone) and
 * never restores it on cancel, so `submitOrder` fails with "The billing details
 * for this order are incomplete." Restoring on cancel loses a race (PayPal
 * re-writes the stub asynchronously), so we heal deterministically right before
 * submit.
 *
 * Source of truth, in order: the in-session snapshot (last COMPLETE address seen
 * while PayPal was idle), else — when the stub was already persisted before this
 * session, so no snapshot exists — the customer's saved address matching the
 * stub's locality. No-op unless the cart address is actually wiped and a real
 * source exists, so a shopper who never touched PayPal is unaffected. Re-selects
 * a shipping option after a shipping write (BC drops it on a zone change) and
 * swallows its own errors so it can't block a submit.
 *
 * `force` (used on PayPal cancel) skips the local stub-check and always writes
 * the source address back to the server. PayPal mutates the SERVER cart through
 * a private integration service that never syncs our main checkoutService, so
 * local state can look complete while the server holds a wiped stub — forcing
 * the write repairs the server without a disruptive `loadCheckout()`.
 */
export var healPaypalWipedAddress = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(checkoutService, options) {
    var _options$force;
    var force, _state$data7, _state$data8, _state$data$getCustom2, _state$data9, state, curBilling, curShipping, shippingWiped, billingWiped, snapshot, savedAddresses, shippingSrc, billingSrc, _curShipping$customFi, merged, result, email, _t4;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          force = (_options$force = options === null || options === void 0 ? void 0 : options.force) !== null && _options$force !== void 0 ? _options$force : false;
          healInFlight = true;
          _context3.p = 1;
          state = checkoutService.getState();
          curBilling = (_state$data7 = state.data) === null || _state$data7 === void 0 ? void 0 : _state$data7.getBillingAddress();
          curShipping = (_state$data8 = state.data) === null || _state$data8 === void 0 ? void 0 : _state$data8.getShippingAddress();
          shippingWiped = force || isStubAddress(curShipping);
          billingWiped = force || isStubAddress(curBilling);
          if (!(!shippingWiped && !billingWiped)) {
            _context3.n = 2;
            break;
          }
          return _context3.a(2);
        case 2:
          // Prefer the in-session snapshot; fall back to the customer's saved address
          // when the stub was persisted from a prior session (no snapshot to use).
          snapshot = getLastGoodAddresses();
          savedAddresses = (_state$data$getCustom2 = (_state$data9 = state.data) === null || _state$data9 === void 0 || (_state$data9 = _state$data9.getCustomer()) === null || _state$data9 === void 0 ? void 0 : _state$data9.addresses) !== null && _state$data$getCustom2 !== void 0 ? _state$data$getCustom2 : [];
          shippingSrc = isCompleteSource(snapshot === null || snapshot === void 0 ? void 0 : snapshot.shipping) ? snapshot === null || snapshot === void 0 ? void 0 : snapshot.shipping : undefined;
          billingSrc = isCompleteSource(snapshot === null || snapshot === void 0 ? void 0 : snapshot.billing) ? snapshot === null || snapshot === void 0 ? void 0 : snapshot.billing : undefined;
          if (shippingWiped && !shippingSrc) {
            shippingSrc = pickSavedAddressForStub(savedAddresses, curShipping);
          }
          if (billingWiped && !billingSrc) {
            billingSrc = pickSavedAddressForStub(savedAddresses, curBilling);
          }

          // Local state can be stale-good while the SERVER holds PayPal's wiped stub
          // (PayPal's private integration service never syncs back), so an identical
          // write is skipped by the SDK and never PUTs. Perturb address2 on a first
          // write to guarantee a real server call, then write the clean address.
          if (!(shippingWiped && shippingSrc)) {
            _context3.n = 5;
            break;
          }
          // Keep any delivery instructions the shopper set on the current shipping.
          merged = _objectSpread(_objectSpread({}, shippingSrc), {}, {
            customFields: curShipping !== null && curShipping !== void 0 && (_curShipping$customFi = curShipping.customFields) !== null && _curShipping$customFi !== void 0 && _curShipping$customFi.length ? curShipping.customFields : shippingSrc.customFields
          });
          _context3.n = 3;
          return checkoutService.updateShippingAddress(_objectSpread(_objectSpread({}, merged), {}, {
            address2: PAYPAL_RESYNC_MARKER
          }));
        case 3:
          _context3.n = 4;
          return checkoutService.updateShippingAddress(merged);
        case 4:
          result = _context3.v;
          _context3.n = 5;
          return reselectShippingOptionIfDropped(checkoutService, result === null || result === void 0 ? void 0 : result.data);
        case 5:
          if (!(billingWiped && billingSrc)) {
            _context3.n = 7;
            break;
          }
          // Preserve the shopper's email, which survives PayPal's wipe.
          email = curBilling !== null && curBilling !== void 0 && curBilling.email ? {
            email: curBilling.email
          } : {};
          _context3.n = 6;
          return checkoutService.updateBillingAddress(_objectSpread(_objectSpread(_objectSpread({}, billingSrc), email), {}, {
            address2: PAYPAL_RESYNC_MARKER
          }));
        case 6:
          _context3.n = 7;
          return checkoutService.updateBillingAddress(_objectSpread(_objectSpread({}, billingSrc), email));
        case 7:
          _context3.n = 9;
          break;
        case 8:
          _context3.p = 8;
          _t4 = _context3.v;
        case 9:
          _context3.p = 9;
          healInFlight = false;
          return _context3.f(9);
        case 10:
          _context3.n = 11;
          return scrubPaypalResyncMarker(checkoutService);
        case 11:
          return _context3.a(2);
      }
    }, _callee3, null, [[1, 8, 9, 10]]);
  }));
  return function healPaypalWipedAddress(_x4, _x5) {
    return _ref7.apply(this, arguments);
  };
}();

/**
 * Re-selects a valid shipping option when BC dropped the selection after a
 * shipping-address write (it does on a zone change), so a subsequent
 * submitOrder isn't rejected for a missing option.
 */
var reselectShippingOptionIfDropped = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(checkoutService, refreshed) {
    var _refreshed$getShippin2, _opts$find2, _checkoutService$getS2;
    var opts, next;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          if (!(!refreshed || refreshed.getSelectedShippingOption())) {
            _context4.n = 1;
            break;
          }
          return _context4.a(2);
        case 1:
          opts = (_refreshed$getShippin2 = refreshed.getShippingOptions()) !== null && _refreshed$getShippin2 !== void 0 ? _refreshed$getShippin2 : [];
          next = (_opts$find2 = opts.find(function (o) {
            return o.type === ShippingMethods.SHIPPING_OPTION_FREE || o.type === ShippingMethods.SHIPPING_OPTION_STANDARD || o.type === ShippingMethods.SHIPPING_OPTION_PERITEM || o.type === ShippingMethods.SHIPPING_BYTOTAL;
          })) !== null && _opts$find2 !== void 0 ? _opts$find2 : opts[0];
          if (!(next && !((_checkoutService$getS2 = checkoutService.getState().statuses) !== null && _checkoutService$getS2 !== void 0 && _checkoutService$getS2.isSelectingShippingOption()))) {
            _context4.n = 2;
            break;
          }
          _context4.n = 2;
          return checkoutService.selectShippingOption(next.id);
        case 2:
          return _context4.a(2);
      }
    }, _callee4);
  }));
  return function reselectShippingOptionIfDropped(_x6, _x7) {
    return _ref8.apply(this, arguments);
  };
}();

/**
 * Replaces a leaked marker with the real address2. The marker REPLACED the
 * shopper's address2 (often the street line, when they keep "Unit 2" in
 * address1), so blanking it would ship to "Unit 2" with no street. Recover the
 * real value from, in order: the in-session snapshot, then a saved address with
 * the same street line + postcode; only blank it when neither exists.
 */
var restoreMarkedAddress = function restoreMarkedAddress(addr, snapshot, saved) {
  var _ref9, _source$address;
  var sameStreet = function sameStreet(a) {
    var _a$address3, _addr$address2, _a$postalCode, _addr$postalCode2;
    return !!a && ((_a$address3 = a.address1) === null || _a$address3 === void 0 ? void 0 : _a$address3.trim().toLowerCase()) === ((_addr$address2 = addr.address1) === null || _addr$address2 === void 0 ? void 0 : _addr$address2.trim().toLowerCase()) && ((_a$postalCode = a.postalCode) === null || _a$postalCode === void 0 ? void 0 : _a$postalCode.trim()) === ((_addr$postalCode2 = addr.postalCode) === null || _addr$postalCode2 === void 0 ? void 0 : _addr$postalCode2.trim());
  };
  var source = (_ref9 = isCompleteSource(snapshot) && sameStreet(snapshot) ? snapshot : undefined) !== null && _ref9 !== void 0 ? _ref9 : saved.find(function (a) {
    var _a$address4;
    return sameStreet(a) && !((_a$address4 = a.address2) !== null && _a$address4 !== void 0 && _a$address4.includes(PAYPAL_RESYNC_MARKER));
  });
  var strip = function strip(v) {
    return (v !== null && v !== void 0 ? v : "").split(PAYPAL_RESYNC_MARKER).join("").trim();
  };
  return _objectSpread(_objectSpread({}, addr), {}, {
    address1: strip(addr.address1),
    address2: source ? (_source$address = source.address2) !== null && _source$address !== void 0 ? _source$address : "" : strip(addr.address2)
  });
};

/**
 * Guard that removes a leaked `__paypal_resync__` marker from the cart's
 * shipping/billing address. No-op when neither address carries it or while a
 * heal is mid-write. Run before submit and whenever checkout state shows the
 * marker, so it can never reach a placed order (~150 AU orders carried it
 * before this guard). Swallows its own errors so it can't block a submit.
 */
export var scrubPaypalResyncMarker = /*#__PURE__*/function () {
  var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(checkoutService) {
    var _state$data0, _state$data1, _state$data$getCustom3, _state$data10, state, shipping, billing, snapshot, saved, result, _t5;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.p = _context5.n) {
        case 0:
          if (!(healInFlight || scrubInFlight)) {
            _context5.n = 1;
            break;
          }
          return _context5.a(2);
        case 1:
          scrubInFlight = true;
          _context5.p = 2;
          state = checkoutService.getState();
          shipping = (_state$data0 = state.data) === null || _state$data0 === void 0 ? void 0 : _state$data0.getShippingAddress();
          billing = (_state$data1 = state.data) === null || _state$data1 === void 0 ? void 0 : _state$data1.getBillingAddress();
          if (!(!hasPaypalResyncMarker(shipping) && !hasPaypalResyncMarker(billing))) {
            _context5.n = 3;
            break;
          }
          return _context5.a(2);
        case 3:
          snapshot = getLastGoodAddresses();
          saved = (_state$data$getCustom3 = (_state$data10 = state.data) === null || _state$data10 === void 0 || (_state$data10 = _state$data10.getCustomer()) === null || _state$data10 === void 0 ? void 0 : _state$data10.addresses) !== null && _state$data$getCustom3 !== void 0 ? _state$data$getCustom3 : [];
          if (!(shipping && hasPaypalResyncMarker(shipping))) {
            _context5.n = 5;
            break;
          }
          _context5.n = 4;
          return checkoutService.updateShippingAddress(restoreMarkedAddress(shipping, snapshot === null || snapshot === void 0 ? void 0 : snapshot.shipping, saved));
        case 4:
          result = _context5.v;
          _context5.n = 5;
          return reselectShippingOptionIfDropped(checkoutService, result === null || result === void 0 ? void 0 : result.data);
        case 5:
          if (!(billing && hasPaypalResyncMarker(billing))) {
            _context5.n = 6;
            break;
          }
          _context5.n = 6;
          return checkoutService.updateBillingAddress(restoreMarkedAddress(billing, snapshot === null || snapshot === void 0 ? void 0 : snapshot.billing, saved));
        case 6:
          _context5.n = 8;
          break;
        case 7:
          _context5.p = 7;
          _t5 = _context5.v;
        case 8:
          _context5.p = 8;
          scrubInFlight = false;
          return _context5.f(8);
        case 9:
          return _context5.a(2);
      }
    }, _callee5, null, [[2, 7, 8, 9]]);
  }));
  return function scrubPaypalResyncMarker(_x8) {
    return _ref0.apply(this, arguments);
  };
}();

/**
 * Clear a stale remote-checkout provider attached to the cart via BC's own
 * `POST /remote-checkout/forget-checkout` (the primitive the SDK uses internally
 * to drop a stuck remote provider -- not exposed on `CheckoutService`, so we hit
 * it directly). Same-origin with the checkout host, so cookies + the XSRF token
 * carry the session; the `X-XSRF-TOKEN` header mirrors BC's csrf-protected
 * request sender (a missing token / Accept is what returns 406). Best-effort:
 * resolves false on any failure so recovery can still try a reload.
 */
export var forgetRemoteCheckout = /*#__PURE__*/function () {
  var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
    var _document$cookie$matc, xsrf, res, _t6;
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.p = _context6.n) {
        case 0:
          if (!(typeof window === "undefined")) {
            _context6.n = 1;
            break;
          }
          return _context6.a(2, false);
        case 1:
          _context6.p = 1;
          xsrf = (_document$cookie$matc = document.cookie.match(/(?:^|; )XSRF-TOKEN=([^;]+)/)) === null || _document$cookie$matc === void 0 ? void 0 : _document$cookie$matc[1];
          _context6.n = 2;
          return fetch("/remote-checkout/forget-checkout", {
            method: "POST",
            credentials: "include",
            headers: _objectSpread({
              Accept: "application/json"
            }, xsrf ? {
              "X-XSRF-TOKEN": decodeURIComponent(xsrf)
            } : {})
          });
        case 2:
          res = _context6.v;
          if (res.ok) {
            _context6.n = 3;
            break;
          }
          return _context6.a(2, false);
        case 3:
          return _context6.a(2, true);
        case 4:
          _context6.p = 4;
          _t6 = _context6.v;
          return _context6.a(2, false);
      }
    }, _callee6, null, [[1, 4]]);
  }));
  return function forgetRemoteCheckout() {
    return _ref1.apply(this, arguments);
  };
}();

/**
 * Recover from the PayPal remote-checkout scope that collapses the express
 * wallets. Using PayPal (its non-hosted `checkout.php` path) attaches a remote
 * provider to the cart, after which BC's `getPaymentMethods()` region-locks and
 * hides Google Pay + Afterpay -- it survives a refresh (server-persisted) and
 * only clears when the cart is mutated. This automates the shopper's manual
 * "update the cart" workaround: forget the remote provider, then reload the
 * method list so the hidden wallets return.
 *
 * `loadCheckout` alone can't fix it (a refresh IS a reload and doesn't), so the
 * forget is the load-bearing step; the reload just re-pulls the now-unscoped
 * list. Login-safe -- forget-checkout clears the remote provider, not the
 * storefront session. Returns the outcome (forget success + reloaded method ids)
 * so callers can beacon whether recovery actually took.
 */
export var recoverWalletScope = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(checkoutService) {
    var forgot, methodIdsAfter, _t7, _t8;
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.p = _context7.n) {
        case 0:
          _context7.n = 1;
          return forgetRemoteCheckout();
        case 1:
          forgot = _context7.v;
          _context7.p = 2;
          _context7.n = 3;
          return checkoutService.loadCheckout();
        case 3:
          _context7.n = 5;
          break;
        case 4:
          _context7.p = 4;
          _t7 = _context7.v;
        case 5:
          _context7.p = 5;
          _context7.n = 6;
          return checkoutService.loadPaymentMethods();
        case 6:
          _context7.n = 8;
          break;
        case 7:
          _context7.p = 7;
          _t8 = _context7.v;
        case 8:
          methodIdsAfter = function () {
            try {
              return (checkoutService.getState().data.getPaymentMethods() || []).map(function (m) {
                return m.id;
              });
            } catch (_unused) {
              return [];
            }
          }();
          return _context7.a(2, {
            forgot: forgot,
            methodIdsAfter: methodIdsAfter
          });
      }
    }, _callee7, null, [[5, 7], [2, 4]]);
  }));
  return function recoverWalletScope(_x9) {
    return _ref10.apply(this, arguments);
  };
}();

/**
 * Backfills an empty `lastName` on the cart's shipping + billing address with
 * the placeholder `"Mofo"` so `submitOrder` / hosted-instrument payments don't
 * get rejected by BigCommerce, which surfaces to the shopper as a
 * message-less "Payment Failed".
 *
 * The express wallets (Apple Pay, Google Pay, PayPal, Afterpay) each run this
 * heal inline before their own submit, but the standard card / saved-instrument
 * path did not — so a returning customer whose restored last-used address had a
 * blank `lastName` field saw repeated silent declines. Idempotent: a no-op when
 * `lastName` is already set, and swallows its own errors so it can never block a
 * submit that would otherwise succeed.
 */
export var healEmptyLastName = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(checkoutService) {
    var _currentState$data, _currentShipping$last, _currentState$data2, currentState, currentShipping, fixedLastName, currentBilling, _t9;
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.p = _context8.n) {
        case 0:
          _context8.p = 0;
          currentState = checkoutService.getState();
          currentShipping = (_currentState$data = currentState.data) === null || _currentState$data === void 0 ? void 0 : _currentState$data.getShippingAddress();
          if (!(!currentShipping || (_currentShipping$last = currentShipping.lastName) !== null && _currentShipping$last !== void 0 && _currentShipping$last.trim())) {
            _context8.n = 1;
            break;
          }
          return _context8.a(2);
        case 1:
          // Absent lastName -> default to "Mofo" (a branded placeholder) rather than
          // the firstName. BC rejects a blank lastName on submit, so we just need a
          // non-empty value the shopper recognises as ours.
          fixedLastName = "Mofo";
          _context8.n = 2;
          return checkoutService.updateShippingAddress(_objectSpread(_objectSpread({}, currentShipping), {}, {
            lastName: fixedLastName
          }));
        case 2:
          currentBilling = (_currentState$data2 = currentState.data) === null || _currentState$data2 === void 0 ? void 0 : _currentState$data2.getBillingAddress();
          if (!currentBilling) {
            _context8.n = 3;
            break;
          }
          _context8.n = 3;
          return checkoutService.updateBillingAddress(_objectSpread(_objectSpread({}, currentBilling), {}, {
            lastName: fixedLastName
          }));
        case 3:
          _context8.n = 5;
          break;
        case 4:
          _context8.p = 4;
          _t9 = _context8.v;
        case 5:
          return _context8.a(2);
      }
    }, _callee8, null, [[0, 4]]);
  }));
  return function healEmptyLastName(_x0) {
    return _ref11.apply(this, arguments);
  };
}();

/** Minimum address fields BC needs populated before `submitOrder` will
 *  succeed for wallet strategies that don't push shipping themselves
 *  (Afterpay, Google Pay via `initializePayment`). */
var WALLET_SHIPPING_REQUIRED_FIELDS = ["firstName", "lastName", "address1", "city", "postalCode", "countryCode"];

/** True when the cart has a real, shopper-supplied shipping address.
 *  Rejects the `Checkout.tsx` warehouse seed (Mofo / User) so wallets
 *  that depend on cart-side shipping don't sail past preflight on a
 *  guest who hasn't filled the address form yet. */
export var isShippingMinimumValid = function isShippingMinimumValid(addr) {
  if (!addr) return false;
  if (addr.firstName === VINOMOFO_WAREHOUSE_ADDRESS.firstName && addr.lastName === VINOMOFO_WAREHOUSE_ADDRESS.lastName) {
    return false;
  }
  var record = addr;
  return WALLET_SHIPPING_REQUIRED_FIELDS.every(function (field) {
    var value = record[field];
    return typeof value === "string" && value.trim().length > 0;
  });
};